import { adapi } from '~';
import clone from 'clone';

const SET_STATUSES = 'SET_STATUSES';
const SET_LOADING = 'SET_LOADING';
const SET_OPTIMIZED_STATUSES = 'SET_OPTIMIZED_STATUSES';

const actions = {
  updateStatuses({ commit }) {
    commit(SET_LOADING, true);
    return adapi.get('resources/statuses')
      .then(statuses => {
        const optimizedStatuses = [];
        Object.values(statuses).forEach(item => {
          item.forEach(status => {
            optimizedStatuses[status.code] = {
              code: status.code,
              name: status.name,
            };
          });
        });

        commit(SET_OPTIMIZED_STATUSES, { statuses: Object.values(optimizedStatuses), error: null });
        commit(SET_STATUSES, { statuses: clone(statuses), error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_STATUSES, { error, statuses: {} });
        commit(SET_LOADING, false);
      });
  },
};

const mutations = {
  [SET_STATUSES](state, { statuses, error }) {
    state.statuses = statuses;
    state.error = error;
  },
  [SET_OPTIMIZED_STATUSES](state, { statuses, error }) {
    state.optimizedStatuses = statuses;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: {
    statuses: {},
    optimizedStatuses: [],
    error: null,
    loading: false,
  },
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/statuses.js